import { Col, Form, Row } from "react-bootstrap";
import {
  Button,
  ButtonsContainer,
  Container,
  ContainerHeader,
  FormContainer,
  IconeTooltipServico,
  Title,
} from "./style";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { CustomInputModal } from "components/CustomInputModal";
import { DropdownSelect } from "components/DropdownSelect";
import { filtroProcessoCriarLoteSchema } from "../../../validate/filtroProcessoCriarLoteSchema";
import { IFiltroProcessoCriarLote } from "../../../interface/IFiltroProcessoCriarLote";
import { useEmpresas } from "hooks/useEmpresas";
import { useEffect, useState } from "react";
import { useDivisoes } from "hooks/useDivisoes";
import { useProcessoFinanceiroAprovar } from "../../../hooks/useProcessoFinanceiroAprovar";
import { useCentroCusto } from "hooks/useCentroCusto";
import { PrimaryButton } from "components/Button/style";
import { useServicoModelo } from "hooks/useServicoModelo";

interface IProps {
  onSubmit: (dados: IFiltroProcessoCriarLote) => void;
  habilitarCancelar: boolean;
  onClickCancelar: () => void;
}
export function FiltroCriarLote({
  onSubmit,
  habilitarCancelar,
  onClickCancelar,
}: IProps) {
  const { register, handleSubmit, reset, control, setValue } = useForm({
    resolver: yupResolver(filtroProcessoCriarLoteSchema),
  });

  const { empresasOptions } = useEmpresas();
  const [empresaSelecionada, setEmpresaSelecionada] = useState<number>();
  const { divisoesOptions, listarTodasDivisoes } = useDivisoes("");
  const [divisaoSelecionada, setDivisaoSelecionada] = useState<number>();
  const onChangeEmpresa = (empresa: any) => {
    setEmpresaSelecionada(empresa);
  };
  const onChangeDivisao = (divisao: any) => {
    setDivisaoSelecionada(divisao);
  };
  useEffect(() => {
    listarTodasDivisoes(empresaSelecionada);

    if (!empresaSelecionada) {
      setValue("servico", null);
      setServicoSelecionado(0);
    }
  }, [empresaSelecionada]);

  const [centroCustoEscolhido, setCentroCustoEscolhido] = useState(null);
  const { centrosCustoOptions } = useCentroCusto(empresaSelecionada, null);

  const onClickLimpar = () => {
    setValue("processos", null);
    setValue("placasChassis", null);
    setValue("servico", null);
    setValue("empresa", null);
    setValue("divisao", null);
    setValue("centroCusto", null);
    setEmpresaSelecionada(undefined);
    setDivisaoSelecionada(undefined);
  };

  const [servicoSelecionado, setServicoSelecionado] = useState<number>();
  const onChangeServico = (servico: any) => {
    setServicoSelecionado(servico);
  };
  const { validarProcessos, validarPlacasChassis } =
    useProcessoFinanceiroAprovar();

  const { servicosModeloOptions, listarServicosModelo } = useServicoModelo();

  useEffect(() => {
    listarServicosModelo({ atualizarOptions: true });
  }, []);

  return (
    <Container>
      <ContainerHeader>
        <Title>Adicionar custos</Title>
        {habilitarCancelar && (
          <PrimaryButton
            variante="primary"
            outline
            onClick={() => onClickCancelar()}
          >
            Cancelar
          </PrimaryButton>
        )}
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Form
          noValidate
          onSubmit={handleSubmit((dados: IFiltroProcessoCriarLote) =>
            onSubmit(dados),
          )}
        >
          <Row style={{ height: 95 }}>
            <Col style={{ maxWidth: "25%" }}>
              <Form.Group>
                <Form.Label>ID Processo</Form.Label>
                <Controller
                  control={control}
                  name="processos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por ID"
                      onConfirm={onChange}
                      onClickOk={validarProcessos}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou copie e cole os IDs dos processos que deseja buscar e tecle ENTER"
                      labelItem="ID Processo"
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col style={{ maxWidth: "25%" }}>
              <Form.Group>
                <Form.Label>Placa ou chassi</Form.Label>
                <Controller
                  control={control}
                  name="placasChassis"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por veículo"
                      onConfirm={onChange}
                      onClickOk={validarPlacasChassis}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou copie e cole as placas ou chassis que deseja buscar e tecle ENTER"
                      labelItem="Placa ou chassi"
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>
                  Serviço{" "}
                  {!empresaSelecionada && (
                    <IconeTooltipServico title="Selecione uma empresa para habilitar este filtro" />
                  )}
                </Form.Label>
                <Controller
                  control={control}
                  name="servico"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={servicosModeloOptions}
                      title=""
                      selectedValue={servicoSelecionado}
                      onSelect={(value) => {
                        onChange(value);
                        onChangeServico(value);
                      }}
                      searchable
                      disabled={!empresaSelecionada}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ height: 80 }}>
            <Col>
              <Form.Group>
                <Form.Label>Empresa</Form.Label>
                <Controller
                  control={control}
                  name="empresa"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={empresasOptions}
                      title=""
                      selectedValue={empresaSelecionada}
                      onSelect={(value) => {
                        onChange(value);
                        onChangeEmpresa(value);
                      }}
                      searchable
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Divisão</Form.Label>
                <Controller
                  control={control}
                  name="divisao"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={divisoesOptions}
                      title=""
                      selectedValue={divisaoSelecionada}
                      onSelect={(value) => {
                        onChange(value);
                        onChangeDivisao(value);
                      }}
                      searchable
                      disabled={!empresaSelecionada}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Centro de custo</Form.Label>
                <Controller
                  control={control}
                  name="centroCusto"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      onSelect={(value) => {
                        setCentroCustoEscolhido(value);
                        onChange(value);
                      }}
                      options={centrosCustoOptions}
                      selectedValue={centroCustoEscolhido}
                      disabled={!empresaSelecionada}
                      title=""
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <ButtonsContainer>
                  <Button
                    type="reset"
                    outline
                    variante="primary"
                    style={{ marginRight: "8px", width: "76px" }}
                    onClick={onClickLimpar}
                  >
                    Limpar
                  </Button>
                  <Button type="submit" style={{ width: "76px" }}>
                    Buscar
                  </Button>
                </ButtonsContainer>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
